<template>
  <div class="entry-overview flex max-w-8xl overflow-hidden bg-white shadow sm:rounded-lg">
    <div class="entry-detail w-full">
      <div class="flex flex-col">
        <!-- Header -->
        <DestinationHeader
          :navigation-tabs="false"
          :button="false" />
        <!-- Main content -->
        <main class="flex-1">
          <div class="relative mx-auto mt-6 p-4">
            <TableWithCondensedContent
              :table-headers="tableHeaders"
              table-bold
              :table-rows="tableRows"
              :items-per-page="25"
              :button="false"
              has-cell-link
              cell-link-text="Go to destination"
              has-paginator
              has-search
              search-placeholder="Search for a destination"
              table-placeholder-text="No destinations found. Please add one by using the button above.">
              <template #header>
                <h2 class="text-lg font-medium text-gray-800">
                  Find your destination
                </h2>
                <p class="mt-2 text-sm text-gray-700">
                  Browse through your current list of {{ tableRows.length }} destinations by paginating,
                  or search for a specific destination by country or place. <br> If you can't find the destination you're
                  looking for, add it by using the button on the right.
                </p>
              </template>
              <template #button>
                <div class="self-end sm:ml-16 sm:flex-none">
                  <button
                    type="button"
                    class="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600
        px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700
        focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                    @click="showModal = true">
                    {{ "Add destination" }}
                  </button>
                </div>
              </template>
            </TableWithCondensedContent>
            <NewDestinationModal
              v-if="showModal"
              :show="showModal"
              :places="places"
              heading="Add more destinations"
              text="Use the search field and select the destination to add to your company's database."
              button-text="Add destination"
              @update:show="(value) => showModal = value"
              @add:place="(value) => addPlaceValue(value)" />
          </div>
        </main>
      </div>
    </div>
  </div>
</template>

<script setup>
/* local */
import {
  computed, ref,
} from 'vue';
import DestinationHeader from '@/Pages/Destination/Components/DestinationHeader.vue';
import TableWithCondensedContent from '@/Components/Lists/TableWithCondensedContent.vue';
import NewDestinationModal from '@/Pages/Destination/Components/DestinationCreateModal.vue';
import SortUpDownIcon from '@/Components/SortUpDownIcon.vue';

const props = defineProps({
  destinations: {
    type: Array,
    required: true,
  },
});

const showModal = ref(false);
const places = ref(props.destinations);

const tableHeaders = [
  'Destination', 'Country', 'Entities', 'Proposals',
];

/* Get data from database and sort it by count of proposals, then entities, descending */
// eslint-disable-next-line vue/no-side-effects-in-computed-properties
const tableRows = computed(() => [...places.value].sort(
  (a, b) => (b.proposals_count - a.proposals_count || b.entities_count - a.entities_count || b.name - a.name),
).map((destination) => [
  destination.name,
  destination.country ?? destination.parent?.name ?? destination.area ?? '',
  destination.entities_count,
  destination.proposals_count,
  route('destinations.show', destination.id),
]));

/**
 * Add place value to places array
 * @param {object} value - place object
 */
function addPlaceValue(value) {
  places.value.push(value);
}

</script>
